module.exports = __webpack_public_path__ + "img/een-logo.9c508f0a.png";